<template>
  <div class="component-container">
    <div v-if="emailInputVisible" class="input-button-container">
      <input v-model="inputData.mail" type="email" placeholder="Please, enter your email" required class="email-input">
      <button @click="submitData" class="submit-button">Submit</button>
    </div>
    <button v-else @click="buttonClicked" class="round-button-normal">{{ label }}</button>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "RoundButtonWithInput",
  props: ['label', 'gradient', 'type'],
  data() {
    return {
      emailInputVisible: false,
      inputData:{
        email: 'test'
      }
    };
  },
  methods: {
    buttonClicked() {
      this.emailInputVisible = true;
    },
    submitData() {
      if (this.isEmailInvalid()) {
        alert('Please enter a valid email.');
      } else if (this.inputData.mail) {
        this.$emit('submit', this.inputData.mail);
        this.emailInputVisible = false; // Optionally reset the view after submission
      } else {
        alert('Please enter your email.');
      }
    },
    isEmailInvalid() {
      return this.inputData.mail && !/^\S+@\S+\.\S+$/.test(this.inputData.mail);
    }
  }
};
</script>

<style lang="scss">
.component-container {
  display: flex;
  justify-content: center;
}

.input-button-container {
  display: flex;
  border: 1px solid #979797; // Border around the entire component
  border-radius: 30px; // Consistent border radius
}

.email-input {
  flex-grow: 1; // Email input takes up available space
  border: none; // Remove individual border
  border-top-left-radius: 30px; // Only round the left side corners
  border-bottom-left-radius: 30px;
  padding: 10px 15px;
  min-width: 350px;
  font-size: 19px;
}

.submit-button {
  border: none; // Remove individual border
  background-color: #bbcd13; // A green background for the submit button
  color: white;
  padding: 10px 24px;
  border-top-right-radius: 30px; // Only round the right side corners
  border-bottom-right-radius: 30px;
  font-size: 19px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s; // Smooth transition for background color
}

.submit-button:hover {
  background-color: #8a970f; // Darken the button on hover
}

.round-button-normal {
  border: 1px solid #979797;
  border-radius: 30px;
  font-size: 19px;
  font-weight: 500;
  padding: 10px 24px;
  background-color: #bbcd13; // Set a background color
  color: rgb(255, 255, 255);
  cursor: pointer;
  transition: background-color 0.3s; // Smooth transition for background color
}

.round-button-normal:hover {
  background-color: #8a970f; // Slightly darken the button on hover
}
</style>
